import type {
    BeginCommerceCheckoutRequest,
    BeginCommerceCheckoutResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const beginCommerceCheckoutOperation = defineCommerceOperation<
    BeginCommerceCheckoutRequest,
    BeginCommerceCheckoutResponse
>("commerce.checkout.begin");
